import { Outlet, useNavigate } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { experimental__simple, dark } from '@clerk/themes';
import { useContext } from 'react';
import { ThemeSwitchingContext } from './App';

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_APP_CLERK_PUBLISHABLE_KEY;

if (!CLERK_PUBLISHABLE_KEY) {
    throw new Error('Missing Clerk Publishable Key');
}

export function RootLayout() {
    const navigate = useNavigate();
    const { activeTheme } = useContext(ThemeSwitchingContext);

    return (
        <ClerkProvider
            routerPush={to => navigate(to)}
            routerReplace={to => navigate(to, { replace: true })}
            publishableKey={CLERK_PUBLISHABLE_KEY}
            appearance={{ baseTheme: activeTheme === 'LIGHT' ? experimental__simple : dark }}
            afterSignOutUrl="/login"
        >
            <Outlet />
        </ClerkProvider>
    );
}
